(() => {
  function initCarousel(car) {
    if (car.dataset.fcInit === "true") return;
    car.dataset.fcInit = "true";
    const track = car.querySelector("[data-carousel-track]");
    const prev = car.querySelector("[data-carousel-prev]");
    const next = car.querySelector("[data-carousel-next]");
    const dots = Array.from(car.querySelectorAll("[data-carousel-dots] .carousel-dot"));
    if (!track) return;
    const items = Array.from(track.children);
    const step = () => track.clientWidth * 0.9;
    function getActiveIndex() {
      const scrollL = track.scrollLeft;
      let best = 0, bestDist = Infinity;
      items.forEach((item, i) => {
        const dist = Math.abs(item.offsetLeft - scrollL);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }
    function update() {
      const idx = getActiveIndex();
      dots.forEach((d, i) => { d.dataset.active = String(i === idx); });
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) prev.dataset.disabled = String(atStart);
      if (next) next.dataset.disabled = String(atEnd);
    }
    if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const idx = parseInt(dot.dataset.dotIndex, 10);
        if (items[idx]) track.scrollTo({ left: items[idx].offsetLeft, behavior: "smooth" });
      });
    });
    let ticking = false;
    track.addEventListener("scroll", () => {
      if (!ticking) { window.requestAnimationFrame(() => { update(); ticking = false; }); ticking = true; }
    }, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  }
  function initAll() { document.querySelectorAll("[data-carousel]").forEach(initCarousel); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else { initAll(); }
  document.addEventListener("shopify:section:load", initAll);
})();
